import KeepCorner from './Corners.vue';
export default KeepCorner;
